import { render } from "./Navbar.vue?vue&type=template&id=2f36181e"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Rafael\\projetos\\laravel\\enjoy_inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__